import { nextTick } from 'vue';

/**
 * Resolves after Vue flushes pending DOM updates and the browser has presented
 * a frame (double requestAnimationFrame). Use when switching layout (e.g. table → map)
 * so toggles and chrome paint before heavy map work on the main thread.
 */
export function afterNextBrowserPaint(): Promise<void> {
  return new Promise((resolve) => {
    void nextTick(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          resolve();
        });
      });
    });
  });
}
